import {Component, Input, Output, EventEmitter} from '@angular/core';
import * as Moment from "moment";
import {extendMoment} from "moment-range";
const moment = extendMoment(Moment);

@Component({
  selector: 'gantt-time-reference',
  templateUrl: './gantt-time-reference.component.html',
  styleUrls: ['./gantt-time-reference.component.css']
})
export class GanttTimeReferenceComponent {
  rangeUnit: any[];
  rangeUnitSup: any[];

  @Input() dataInicial;
  @Input() dataFinal;
  @Input() configEsc: {};

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.rangeUnit = this.getEsc(this.configEsc['unit'], this.configEsc['format']);
    this.rangeUnitSup = this.getEsc(this.configEsc['unitSuperior'],
      this.configEsc['formatSuperior']);
    this.rangeUnitSup = this.getWidthEscSuperior(this.rangeUnitSup, this.configEsc);
  }

  getEsc(unit, format) {
    let defRangeUnit = moment.range(this.dataInicial, this.dataFinal);
    let rangeArray = Array.from(defRangeUnit.by(unit));

    return rangeArray.map((item) => {
      return {caption: moment(item).format(format), moment: item};
    });
  }

  getWidthEscSuperior(range, configEsc) {
    return range.map((item)=> {
      item['style'] = {width: ''};
      let endOf = moment(item.moment, 'MM-DD-YYYY').endOf(configEsc.unitSuperior);
      let size = endOf.diff(this.dataInicial, configEsc.unit) + 1;
      item.style.width = size * configEsc.widthUnit + 'px';
      return item
    });
  }
}
